module.exports = __webpack_public_path__ + "src/components/WhyHost/MoreSection/2.jpg?c95a2bba";


//////////////////
// WEBPACK FOOTER
// ./src/components/WhyHost/MoreSection/2.jpg
// module id = 3385
// module chunks = 8